import protoRoot from "@/proto/proto";
import { webSocketLogin,webSocketEnterChatRoom} from './websocket_core';

//获取用户登录状态
function getUserStatus() {
  const userInfo = $nuxt.$cookies.get('userInfo')
  if (userInfo) {
    return true
  } else {
    return false
  }
}
//收到消息
export function receiveMessage(evt) {
  const userInfo = $nuxt.$cookies.get('userInfo'),
    token = $nuxt.$cookies.get('token');
  let bytes = evt.data;
  let cmd = readByte(bytes, 4);//cmd
  let isHeartBeat = bytes != null && bytes.length == 1 && bytes[0] == -33;//cmd
  let length = bytes.length;
  if (isHeartBeat) {
    //console,log("心跳", "收到心跳回复")
    return;
  }
  let bodySize = readInt(bytes, 0);//bodySize

  let cc = readShort(bytes, 5);//校验位
  let flags = readByte(bytes, 7);//标志位
  let sessionId = readInt(bytes, 8);//sessionId
  let lrc = readByte(bytes, 12);//lrc
  let PBMessageRequest, message;
  switch (cmd) {
    case 2://成功回复消息,没有参数，只有提醒，如果有参数需要返回，则需要单独消息体
      PBMessageRequest = protoRoot.lookup(
        "com.lawback.push.core.pb.Ok"
      );
      message = readBody(bytes.subarray(13), length, PBMessageRequest);
      // 用户进入到直播间聊天房
      if (message.cmd === 104) {
        let enterMsg = { ...message }
        console.log("-------WEBSOKET用户加入聊天室----------")
        $nuxt.$store.commit('chatRoomMsg', enterMsg)
      }
      if (message.cmd === 100) {
        console.log("-------WEBSOKET用户绑定成功----------")
        $nuxt.$store.commit('SET_BINDSUCCESS', 1)
      }
      //在其他地方登录 弹框提示  想办法在页面上进行弹框。通用。
      //console,log("收到ok回复", cmd, readBody(bytes.subarray(13), length, PBMessageRequest))
      break;
    case 3://失败
      PBMessageRequest = protoRoot.lookup(
        "com.lawback.push.core.pb.Error"
      );
      //在其他地方登录 弹框提示  想办法在页面上进行弹框。通用。
      console.error("收到error回复", cmd, readBody(bytes.subarray(13), length, PBMessageRequest))
        let message = readBody(bytes.subarray(13), length, PBMessageRequest);
      if((message.cmd==104 || message.cmd==103) && message.code==5 ){
        console.log("-------WEBSOKET用户绑定失败----------")
        webSocketLogin(userInfo, token);
      }
      if((message.cmd==103) && message.code==-25){
        webSocketEnterChatRoom({id:$nuxt.$store.state.chatRoomId});
      }
      break;
    case 5://链接OK返回
      PBMessageRequest = protoRoot.lookup(
        "com.lawback.push.core.pb.ConnectOk"
      );
      //在其他地方登录 弹框提示  想办法在页面上进行弹框。通用。
      message = readBody(bytes.subarray(13), length, PBMessageRequest);
      let sessionId = message.sessionId;
      let heartbeat = message.heartbeat;
      let expireTime = message.expireTime;
      let webSocketLoginRes = webSocketLogin(userInfo, token);
      break;
    case 102://网关消息：//TODO 这里处理业务逻辑
      PBMessageRequest = protoRoot.lookup(
        "com.lawback.push.core.pb.GatewayPush"
      );
      message = readBody(bytes.subarray(13), length, PBMessageRequest);
      let id = message.id;
      let uid = message.uid;
      let content = message.ext ? JSON.parse(message.ext) : {};//消息体，json类型
      let contentType = message.contentType;//消息类型 order_payed:订单支付成功，order_refunded：订单退款成功 ，order_alloc_lawyer_upload：律师上传了文件
      // $nuxt.$store.dispatch('unread')

      if(contentType == "wechat_public_login") {
        if (content.token) { //有token時直接登录
          $nuxt.$store.dispatch("closeDialogAndUpdateUserInfo", content.token);
          if ($nuxt.$route.path === '/login') {
            $nuxt.$router.replace('/')
          } else {
            window.location.reload();
          }
        } else {  //没有token時表示用户没有注册  去到注册页
          $nuxt.$store.commit("showLoginDialog", false);
          $nuxt.$router.push({
            path: '/register', query: {
              openid: content.openid,
              unionid: content.unionid
            }
          })
        }
        return
      }
      // 访问人数
        if(contentType=='forum_visit_notify'){
          if(content.year=='2022'){
            if(content.bid === 'ccpit'){
              $nuxt.$store.commit('SET_VISIT',content.totalVisit)
            }
          }
        }
      //在其他地方登录 弹框提示  想办法在页面上进行弹框。通用。
      if (contentType == "order_payed") {
        /*更新消息*/
        let params = {
          orderNo: content.orderNo,
          orderType: content.orderType,
          ext: content.ext
        }
        // $nuxt.$store.dispatch('unread');
        $nuxt.$message({
          message: '支付成功',
          type: 'success',
          duration: 1000,
          onClose: () => {
            $nuxt.$router.replace({
              path: "/successful",
              query: {
                params: $nuxt.$Base64.encode(JSON.stringify(params))
              }
            })
          }
        })
        return
      } else if (contentType == 'live_state_change_push') {
        console.log("合并直播状态等信息",$nuxt.$store.state.currentLiveData,content)
        $nuxt.$store.commit("MERGE_CURRENTLIVEDATA",content);
      } else if (contentType == 'live_quantity_change_push') {
        $nuxt.$store.commit("SET_LIVEQUANTITY", content);
      }
      break;
    case 103: //直播相关 用户收到消息
      PBMessageRequest = protoRoot.lookup(
        "com.lawback.push.core.pb.ChatRoomMessage"
      );
      message = readBody(bytes.subarray(13), length, PBMessageRequest);
      let sentMsg = { ...message }
      console.log("用户消息xxxxxxxxxxx",JSON.stringify(sentMsg))
      if(sentMsg.operator==1){
        $nuxt.$store.commit("deleteChatRoomMsg", sentMsg.msgId)
        return;
      }
      if (sentMsg.fromUid == userInfo.uid) sentMsg.type = 'myMsg'; // 区分是否为自己所发送的消息
      $nuxt.$store.commit('chatRoomMsg', sentMsg)
      return
      break;
    case 106: //管理员设置用户发言状态
      PBMessageRequest = protoRoot.lookup(
        "com.lawback.push.core.pb.ChatRoomUserState"
      );
      message = readBody(bytes.subarray(13), length, PBMessageRequest);
      let setMsg = { ...message }
      console.log("用户消息",setMsg)
      $nuxt.$store.commit('chatRoomUserState', setMsg)
      $nuxt.$store.commit('chatRoomMsg', setMsg)
      return
      break;
  }
}

function readByte(bytes, pos) {
  return bytes[pos]
}

function readShort(bytes, off) {
  return (bytes[off] << 8) + bytes[off + 1]
}

function readInt(bytes, off) {
  return (bytes[off] << 24) + (bytes[off + 1] << 16) + (bytes[off + 2] << 8) + bytes[off + 3]
}


function readBody(data, length, PBMessageRequest) {
  let bytes = new Uint8Array(data, length);
  let message = PBMessageRequest.decode(bytes);
  return message;
}

